import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Rx";

import {AngularFireStorage} from "angularfire2/storage";
import {Constants} from "../../helper/constants";

@Injectable()
export class FileUploadService {

  constructor(private afStorage: AngularFireStorage) {
  }

  upload(path, file): Observable<string> {
    const fileNameArr = file.name.split(".");
    let delimiter = Date.now().toString();
    delimiter = `-${delimiter.substr(delimiter.length - 2, delimiter.length)}.`;
    const filename = fileNameArr.join(delimiter);
    const uploadTask = this.afStorage.upload(`/${path}/${filename}`, file);

    return uploadTask.downloadURL();
  }

  verifyFileIsCSV(event): { file: any, message?: String } {
    if (event.target && event.target.files && event.target.files.length) {
      const file = event.target.files[0];

      return (!file.name.includes(Constants.CSV)) ? {file} : {file: false, message: "File must be a csv document"};
    } else {
      return {file: false, message: "Please upload a valid csv document"};
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/fileuploadservice.ts